import { getConfig } from "../../config/configuration";
import { AnnualFinals } from "./models";

class AnnualFinalsApi {
    public static async load(year: string): Promise<AnnualFinals> {
        const config = await getConfig();

        const response = await fetch(`${config.apiUrl}/leagues/open/${year}/annual-finals`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            method: 'GET'
        });

        if (response.ok) {
            return await response.json();
        }

        throw new Error(response.statusText);
    }
}

export default AnnualFinalsApi;
